"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.highPrecisionFractionDigits = exports.getCurrencyFractionDigits = exports.currenciesConfig = void 0;
/**
 * In future when more we will need to support more currencies we can decide to move it in some storage (CT?).
 */
exports.currenciesConfig = {
    AED: {
        fractionDigits: 2,
    },
    SAR: {
        fractionDigits: 2,
    },
};
function getCurrencyFractionDigits(currencyCode) {
    const currencyFractionDigits = exports.currenciesConfig[currencyCode]?.fractionDigits;
    if (!currencyFractionDigits) {
        throw new Error(`There is no fraction digits configuration for ${currencyCode}`);
    }
    return currencyFractionDigits;
}
exports.getCurrencyFractionDigits = getCurrencyFractionDigits;
/**
 * For high precision money we use 4 fraction digits.
 */
exports.highPrecisionFractionDigits = 4;
//# sourceMappingURL=common.js.map